import { render, staticRenderFns } from "./Carousel2El.vue?vue&type=template&id=78e2eb63&scoped=true&"
import script from "./Carousel2El.vue?vue&type=script&lang=ts&"
export * from "./Carousel2El.vue?vue&type=script&lang=ts&"
import style0 from "./Carousel2El.vue?vue&type=style&index=0&id=78e2eb63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e2eb63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCarousel,VCarouselItem,VIcon,VSheet})
